<template>
  <div v-if="visible" class="modal-overlay" @click="close">
    <div class="modal-content" @click.stop>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalContainer',
  data() {
    return {
      visible: false
    };
  },
  methods: {
    close() {
      this.visible = false;
    }
  }
};
</script>